import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
export const useIsHeadersNavPhase1Enabled = () => {
    const treatment = useExperimentTreatmentWithoutReporting(Experiment.NavPhase1);
    return ['pillars_header_menu', 'pillars_header_menu_search', 'pillars_header'].includes(treatment);
};
//# sourceMappingURL=useIsHeadersNavPhase1Enabled.js.map